module.exports = __webpack_public_path__ + "web/img/flac.8d929590.png";